// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"c8f600e004bd049074de","404":"9c5e0eb6bd9d07a0d00a","406":"e994b4ded6e7fd4f22cc"}[chunkId] + ".css";
};